export default __webpack_public_path__ + "static/media/001.87c29940.jpg";